import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import setupAxiosInterceptors from './Services/axiosInterceptor';
import { startTokenRefresher } from './Services/tokenRefresher';
import { urlBuilding } from './config/apiConfig';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './ErrorBoundary';
import { ErrorProvider } from './Context/Error/errorContext';
import GlobalErrorToasts from './Components/GlobalErrorToasts/GlobalErrorToasts';

try {
  // Setup axios interceptors synchronously before rendering the app
  // This ensures the interceptors exist for any requests made during initial mount
  const backendUrl =
    window.location.hostname.indexOf('stage') > -1
      ? urlBuilding.stageUrl
      : urlBuilding.localUrl;

  const onTokenExpired = () => {
    // fallback logout handler when router navigation isn't available yet
    // Initialize logout flag only in specific debug/test scenarios, not by default
    // try { localStorage.setItem('goToLogout', 'true'); } catch (e) {}
    window.location.href = '/logout';
  };

  setupAxiosInterceptors(onTokenExpired, backendUrl);

  // Start proactive refresher with ~90s skew and one retry with jitter
  startTokenRefresher(backendUrl, {
    skewSeconds: 90,
    intervalMs: 15000,
    retry: true,
    onExpired: onTokenExpired,
  });

  const root = ReactDOM.createRoot(document.getElementById('root'));
  console.log('Root element created');
  root.render(
    <React.StrictMode>
      <ErrorProvider>
        <ErrorBoundary>
          <div className="container">
            <App />
            <GlobalErrorToasts />
          </div>
        </ErrorBoundary>
      </ErrorProvider>
    </React.StrictMode>
  );
  console.log('App rendered successfully');
} catch (error) {
  console.error('ERROR: Failed to render app:', error);
  console.error('Stack trace:', error.stack);
  // Write error to DOM so it's visible if console is closed
  const rootElement = document.getElementById('root');
  if (rootElement) {
    rootElement.innerHTML = `<div style="color: red; padding: 20px; font-family: monospace;"><h2>App Initialization Error:</h2><pre>${error.message}\n\n${error.stack}</pre></div>`;
  }
}

reportWebVitals();
